const DEFAULT_CLASS_NAME = 'absolute right-0 top-0 pointer-events-none px-1 border-2 border-white rounded-xl bg-green-600 text-white text-xs leading-tight flex items-center justify-center font-bold';
function createCounter(className) {
    const counter = document.createElement('span');
    counter.className = className;
    counter.setAttribute('data-counter', '');
    return counter;
}
export function addNotificationIcon({ items, label, count, }) {
    items.forEach((item) => {
        var _a;
        const className = (_a = item.getAttribute('data-notification-class')) !== null && _a !== void 0 ? _a : DEFAULT_CLASS_NAME;
        item.setAttribute('aria-label', label);
        let counterNode = item.querySelector('[data-counter]');
        if (count === 0) {
            counterNode === null || counterNode === void 0 ? void 0 : counterNode.remove();
            return;
        }
        if (!counterNode) {
            counterNode = createCounter(className);
            item.appendChild(counterNode);
        }
        counterNode.innerHTML = String(count);
    });
}
